import { useEffect, useState } from 'react';
import useApi, { GET_COMMON_USED_BENCHMARKS, GET_AVAILABLE_PORTFOLIOS } from 'hooks/useApi';

export const useCommonBenchmarks = selectedBenchmarks => {
  const [filteredBenchmarks, setFilteredBenchmarks] = useState();
  const apiParams = GET_COMMON_USED_BENCHMARKS();
  const [state] = useApi(apiParams);
  const { isLoading, isError, data, error } = state;

  useEffect(() => {
    if (isLoading) {
      return;
    }

    if (isError && error) {
      return;
    }

    if (data) {
      const formattedSeries = [...data.data]
        .filter(
          b =>
            !selectedBenchmarks.find(b2 => b2.benchmarkId === b.benchmarkId && b2.name === b.name)
        )
        .map(series => ({
          label: series.name,
          value: series.benchmarkId
        }));

      setFilteredBenchmarks(formattedSeries);
    }
  }, [isLoading, isError, error, data, selectedBenchmarks]);

  const addToResults = benchmark => {
    const mappedResult = {
      label: benchmark.name,
      value: benchmark.benchmarkId
    };

    const updatedResults = [...filteredBenchmarks];
    updatedResults.unshift(mappedResult);
    setFilteredBenchmarks(updatedResults);
  };

  return [state, filteredBenchmarks, addToResults];
};

export const useAvailablePortfolios = () => {
  const [filteredPortfolios, setFilteredPortfolios] = useState();
  const apiParams = GET_AVAILABLE_PORTFOLIOS();
  const [state] = useApi(apiParams);
  const { isLoading, isError, data, error } = state;

  useEffect(() => {
    if (isLoading) {
      return;
    }

    if (isError && error) {
      return;
    }

    if (data) {
      const formattedSeries = [...data].map(portfolio => ({
        label: portfolio.name,
        value: portfolio.id
      }));
      setFilteredPortfolios(formattedSeries);
    }
  }, [isLoading, isError, error, data]);

  return [state, filteredPortfolios];
};
